module.exports = __webpack_public_path__ + "static/awards-01-f088075cc1c4a08269597c5bf983ddec.png";